import React, { useState } from 'react';
import styled, { css } from "styled-components";
import { PlusCircleFill, XCircleFill } from 'react-bootstrap-icons';
import { Collapse } from 'react-collapse';

type FaqQuestionCollapseProps = {
    question: string;
    answer: string;
}
type DivProps = {
    $isOpen: boolean;
}
const QuestionContainer = styled.div<DivProps>`
    display:flex;
    font-family: Lato-Bold;
    font-size: 1.1em;
    margin-top:1em;
    padding:1em;
    background-color: ${props => props.$isOpen ? "var(--main-teal-color)" : "var(--main-orange-color)"};
    color: #fff;
    cursor:pointer;
    overflow:hidden;
    transition: all 0.3s ease 0s;
        :hover {
            box-shadow: rgb(38, 57, 77) 0px 20px 30px -10px;
            transition: all 0.3s ease 0s;
        }
`;
const iconStyle = css<DivProps>`
    float:right;
    font-size: 2em;
    color: ${props => props.$isOpen ? "var(--main-orange-color)" : "var(--main-teal-color)"};
`;

const OpenIcon = styled(PlusCircleFill)`
    ${iconStyle}
`;

const CloseIcon = styled(XCircleFill)`
    ${iconStyle}
`;

const AnswerContainer = styled.div`
    font-family: Lato-Regular;
    font-size: 0.9em;
    padding:1em;
    transition: all 0.3s ease 0s;
    color:var(--main-grey-color);
    border: 2px solid var(--main-orange-color);
    border-top: 0px;
`;
const IconWrapper = styled.div`
    flex:display;
    align-items:center;
    height: 100%;
`;

function FaqQuestionCollapse({ question, answer }: FaqQuestionCollapseProps) {

    const [isOpen, setIsOpen] = useState<boolean>(false);

    const toggle = () => setIsOpen(!isOpen);

    return (
        <>
            <QuestionContainer $isOpen={isOpen} onClick={toggle}>
                <div style={{width: "100%"}}>
                    {question}
                </div>
                <IconWrapper>
                    {isOpen ?
                        <CloseIcon $isOpen={isOpen} /> :
                        <OpenIcon $isOpen={isOpen} />
                    }
                </IconWrapper>
            </QuestionContainer>
            <Collapse isOpened={isOpen}>
                <AnswerContainer>
                    <div dangerouslySetInnerHTML={{__html: answer }} />
                </AnswerContainer>
            </Collapse>
        </>
    );
}
export default FaqQuestionCollapse;
